import { Card, CardContent, Skeleton, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { useSelector } from '../../../reduxToolkit/typedRedux';
import { getLastMatchesCount } from '../../../services/services';
import VyTooltip from '../../common/VyTooltip';

const LastMatches = () => {
  const event = useSelector(({ common }) => common.event);

  const { t } = useTranslation();

  const [count, setCount] = useState<Number>();

  useEffect(() => {
    if (!event) return;
    fetchLastMatchesCount(event._id);
  }, [event]);

  const fetchLastMatchesCount = async (eventId: string) => {
    const { data } = await getLastMatchesCount(eventId);
    setCount(data.count);
  };

  return (
    <Card className="w-48 my-2" elevation={0}>
      {count === undefined ? (
        <div className="m-4">
          <Skeleton animation="wave" height={30} width="60%" style={{ marginBottom: 6 }} />
          <Skeleton animation="wave" height={30} width="20%" style={{ marginBottom: 6 }} />
        </div>
      ) : (
        <CardContent>
          <Typography className="font-size: 1rem;line-height: 1.5rem;" color="textSecondary" gutterBottom>
            <VyTooltip title={t('account:matching.tooltip-last-matches-count')}>{t('account:matching.last-matches-count')}</VyTooltip>
          </Typography>
          <Typography variant="h5" component="h2">
            {count.toString()}
          </Typography>
        </CardContent>
      )}
    </Card>
  );
};
export default LastMatches;
